import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";
import { useAudio } from "@/context/AudioContext";

export const AudioToggle = () => {
  const audio = useAudio();
  const playing = audio?.playing;

  return (
    <button
      data-testid="audio-toggle-btn"
      data-audio-toggle
      onClick={() => audio?.toggle()}
      aria-label={playing ? "Mute music" : "Play music"}
      className="fixed bottom-6 right-6 z-[90] flex items-center gap-3 rounded-full glass px-4 py-3 group hover:border-magenta/60 transition-colors duration-300"
    >
      <span className="relative flex h-8 w-8 items-center justify-center">
        {playing && (
          <span className="absolute inset-0 rounded-full bg-magenta/30 animate-pulse-glow" />
        )}
        <AnimatePresence mode="wait" initial={false}>
          {playing ? (
            <motion.span key="on" initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.6, opacity: 0 }}>
              <Volume2 className="h-5 w-5 text-magenta" />
            </motion.span>
          ) : (
            <motion.span key="off" initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.6, opacity: 0 }}>
              <VolumeX className="h-5 w-5 text-white/70" />
            </motion.span>
          )}
        </AnimatePresence>
      </span>
      <span className="hidden sm:flex flex-col leading-none pr-1">
        <span className="font-display text-lg tracking-[0.15em] text-white">{playing ? "SOUND ON" : "MUTED"}</span>
        <span className="text-[10px] uppercase tracking-[0.25em] text-white/40">Ambient</span>
      </span>
      {/* Equalizer bars */}
      <span className="hidden sm:flex items-end gap-[3px] h-6">
        {[0, 1, 2, 3].map((i) => (
          <motion.span
            key={i}
            className="w-[3px] rounded-full bg-gradient-to-t from-violet to-magenta"
            animate={playing ? { height: ["30%", "100%", "45%", "80%", "30%"] } : { height: "20%" }}
            transition={playing ? { duration: 0.9 + i * 0.15, repeat: Infinity, ease: "easeInOut" } : {}}
            style={{ height: "20%" }}
          />
        ))}
      </span>
    </button>
  );
};
